export const UPLOAD_PRODUCTS_COLUMNS = {
    BARCODE:           'Código de barras',
    PRESENTATION:      'Presentación*',
    SUBCATEGORY:       'Subcategoría*',
    NAME:              'Nombre del producto*',
    ABBREVIATION:      'Abreviatura*',
    DESCRIPTION:       'Descripción del producto*',
    EXTERNAL_ID:       'ID externo(SKU)',
    ITEM_MASTER_SKU:   'Ítem master',
    UNIT_WEIGHT:       'Unidad de peso*',
    WEIGHT:            'Peso*',
    UNIT_DIMENSIONS:   'Unidad (dimensiones)*',
    WIDTH:             'Ancho*',
    HEIGHT:            'Alto*',
    LENGTH:            'Largo*',
    RECEIPT_UNIT_MEASURE: 'Unidad de medida para recibo',
    DISPATCH_UNIT_MEASURE: 'Unidad de medida para despacho',
    PRICE_PER_UNIT:         'Costo por unidad*',
    COMMERCIAL_PRICE:  'Valor comercial*',
    SHELF_LIFE_DAYS:   'Vida útil',
    MAX_DISPATCH_DAYS: 'Plazo máximo para despachar (días)',
};

export const UPLOAD_PRODUCTS_HEADERS = Object.values(UPLOAD_PRODUCTS_COLUMNS).join(';');

export const handleDownloadTemplateBulkProducts = () => {
    const fileName = 'Plantilla-cargue-de-productos.csv';
    const blob = new Blob([UPLOAD_PRODUCTS_HEADERS], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
